import { useState, useEffect, useContext, useMemo } from 'react'
import { useLocation, useParams, useNavigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'
import { getPass } from '/providers/passes-api'
import { Typography } from '@mui/material'

import PageWrapper from '/components/page-wrapper'
import StyledPaper from '/components/paper'
import HelpText from '/help/pass-details'
import Menu from '/components/passes/pass-nav-menu'

import EditForm from '/components/passes/editor.jsx'

const PassEditor = () => {

  const navigate = useNavigate()
  const location = useLocation()

  const { templateId, passId } = useParams()
  const { apiSource, apiKey, templates, setPasses } = useContext(AppContext)
  const [pass, setPass] = useState(location.state?.pass)
  const template = useMemo(() => { return templates.filter(t => t.template_id === templateId)[0] }, [templates, templateId])

  useEffect(() => {
    getPassData()
  }, [])

  const getPassData = async () => {
    const p = await getPass({ apiSource, apiKey, templateId, passId })
    if (p.ok === false || !p.pass) return navigate("/templates")
    setPasses(current => {
      const idx = current.findIndex(item => item.template_id === templateId && item.pass_id === passId)
      if (idx < 0) return [...current, p.pass]
      const next = [...current]
      next[idx] = p.pass
      return next
    })
    setPass(p.pass)
  }

  const setLocationStatePass = pass => {
    setPass(pass)
    setPasses(current => {
      const idx = current.findIndex(item => item.template_id === templateId && item.pass_id === passId)
      if (idx < 0) return [...current, pass]
      const next = [...current]
      next[idx] = pass
      return next
    })
    navigate(location.pathname, { replace: true, state: { ...location.state, pass } })
  }

  return (
    <PageWrapper title="Pass Editor" HelpText={HelpText} heading={`${pass?.pass_id} ${pass?.mode === "test" ? " [test]" : ""}`} menu={<Menu pass={pass} template={template} />}>
      <Content templateId={templateId} pass={pass} getPass={getPassData} setPass={setLocationStatePass} />
    </PageWrapper>
  )
}

export default PassEditor

const Content = ({ templateId, pass, setPass }) => {

  return (
    <div className='h-full min-h-0 w-full'>
      <div className='flex h-full min-h-0 w-full gap-4'>
        <StyledPaper sx={{ flex: 1, minWidth: 0, height: '100%' }}>
          <Typography variant='h4'>Pass (Instance) Data</Typography>
          <EditForm pass={pass} templateId={templateId} setPass={setPass} />
        </StyledPaper>
      </div>
    </div>
  )
}
